import axios from "axios";
import config from "./config";

const BASE_URL = config.baseApi;

/**
 * Get authentication token from localStorage
 * @returns {string|null} Token or null if not found
 */
const getAuthToken = () => {
  try {
    const carMeetStorageString = localStorage.getItem("car-meet-storage");
    if (!carMeetStorageString) return null;
    
    const carMeetStorage = JSON.parse(carMeetStorageString);
    return carMeetStorage?.token || null;
  } catch (error) {
    console.error("Error parsing auth storage:", error);
    return null;
  }
};

/**
 * Clear authentication data and redirect to login
 */
const clearAuthAndRedirect = () => {
  localStorage.removeItem("car-meet-storage");
  localStorage.clear();
  window.location.href = "/";
};

// Create axios instance
const customAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // increase to 30 seconds to avoid premature Network Error on slow endpoints
});

// Request interceptor - Add auth token
customAxios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle auth errors
customAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      
      // Handle authentication errors
      if (status === 401 || status === 403) {
        clearAuthAndRedirect();
        return Promise.reject(error);
      }
      
      // Log other errors for debugging
      console.error(`API Error [${status}]:`, error.response.data);
    } else if (error.request) {
      // Network error
      console.error("Network Error:", error.message);
    } else {
      // Other error
      console.error("Error:", error.message);
    }
    
    return Promise.reject(error);
  }
);

export default customAxios;
